<div class="header">
  <h1>{{ tenantName || "Tenant" }} Settings</h1>
  <div class="buttons">
    <div
      class="transparent-outlined"
      title="cancel changes"
      (click)="onCancel()"
    >
      <div>Cancel</div>
    </div>
    <div class="fill-outlined" title="apply changes" (click)="onSaveChanges()">
      <div *ngIf="!saveChangesProcessing">Apply Changes</div>
      <div *ngIf="saveChangesProcessing">Processing...</div>
    </div>
  </div>
</div>
<div class="main" *ngIf="tenantSettings">
  <mat-tab-group
    animationDuration="0ms"
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab *ngFor="let tab of tabs" [label]="tab.label">
      <div class="view">
        <div class="categories" #categories>
          <ul>
            <ng-container
              *ngTemplateOutlet="tab.categoriesTemplate"
            ></ng-container>
          </ul>
        </div>
        <div class="form" #form>
          <ng-container *ngTemplateOutlet="tab.formTemplate"></ng-container>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #generalSettingsCategoriesTemplate>
  <li (click)="onCategoryClick('general-settings-original-files', $event)">
    Original files
  </li>
  <li (click)="onCategoryClick('general-settings-media-information', $event)">
    Media Information
  </li>
  <li (click)="onCategoryClick('general-settings-transcoding', $event)">
    Transcoding
  </li>
  <li (click)="onCategoryClick('general-settings-automated-qc', $event)">
    Automated QC
  </li>
  <li (click)="onCategoryClick('general-settings-recording-feature', $event)">
    Recording Feature
  </li>
  <li (click)="onCategoryClick('general-settings-scheduler', $event)">
    Scheduler
  </li>
  <li
    (click)="onCategoryClick('general-settings-channel-future-preview', $event)"
  >
    Channel Future Preview
  </li>
  <li (click)="onCategoryClick('general-settings-operations', $event)">
    Operations
  </li>
  <li (click)="onCategoryClick('general-settings-metadata', $event)">
    Metadata
  </li>
  <li (click)="onCategoryClick('general-settings-tags', $event)">Tags</li>
  <li (click)="onCategoryClick('general-settings-qc-workflow', $event)">
    QC Workflow
  </li>
  <li (click)="onCategoryClick('general-settings-broadcasts', $event)">
    Broadcasts
  </li>
</ng-template>
<ng-template #generalSettingsFormTemplate>
  <fieldset id="general-settings-original-files">
    <legend>Original files</legend>
    <div class="ts-form-group">
      <p class="ts-info-description">
        Checking this will delete the original files from S3 storage, please
        click with caution
      </p>
      <span class="ts-info-note"
        >* This is applicable only for the original files upload. Your
        transcoded files will be kept.</span
      >
      <div class="ts-action">
        <div
          class="checkbox-input checkbox-input-burn-subs"
          [class.active]="tenantSettings.DeleteOriginalMediaFiles"
        >
          <div (click)="onDeleteOriginalFilesChanged()">
            <svg viewBox="0 0 21.02 14.02">
              <path
                fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
              />
            </svg>
          </div>
        </div>
        <span class="label">Delete original files</span>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-media-information">
    <legend>Media Information</legend>
    <div class="ts-form-group">
      <p class="ts-info-description">
        Reveal the "Liecnse" tab in media editor
      </p>
      <div class="ts-action">
        <div
          class="checkbox-input checkbox-input-burn-subs"
          [class.active]="tenantSettings.ShowMediaLicenseSettings"
        >
          <div (click)="onShowMediaLicenseSettingsChanged()">
            <svg viewBox="0 0 21.02 14.02">
              <path
                fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
              />
            </svg>
          </div>
        </div>
        <span class="label">Show "License" Tab</span>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-transcoding">
    <legend>Transcoding</legend>
    <div class="ts-form-group">
      <div class="ts-action">
        <div
          class="checkbox-input checkbox-input-burn-subs"
          [class.active]="tenantSettings.TranscodeBypassFeatureEnabled"
        >
          <div (click)="onTranscodeBypassFeatureChanged()">
            <svg viewBox="0 0 21.02 14.02">
              <path
                fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
              />
            </svg>
          </div>
        </div>
        <span class="label">Enable transcode bypass feature</span>
      </div>

      <div
        class="ts-action"
        *ngIf="tenantSettings.TranscodeBypassFeatureEnabled"
      >
        <div
          class="checkbox-input checkbox-input-burn-subs"
          [class.active]="tenantSettings.ByPassWithGeneratingLowRes"
        >
          <div (click)="onByPassWithGeneratingLowResChanged()">
            <svg viewBox="0 0 21.02 14.02">
              <path
                fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
              />
            </svg>
          </div>
        </div>
        <span class="label"
          >ByPass with generating - LR for faster segmentation</span
        >
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-automated-qc">
    <legend>Automated QC</legend>
    <div class="ts-form-group">
      <p class="ts-info-description">
        Checking this will allow the QC analyze when uploading video files.
      </p>
      <div class="ts-action">
        <div
          class="checkbox-input checkbox-input-burn-subs"
          [class.active]="tenantSettings.DoQcAnalizeWhenUploading"
        >
          <div (click)="onDoQcAnalizeWhenUploadingChanged()">
            <svg viewBox="0 0 21.02 14.02">
              <path
                fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
              />
            </svg>
          </div>
        </div>
        <span class="label">Perform QC analyzing</span>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-recording-feature">
    <legend>Recording Feature</legend>
    <div class="ts-form-group">
      <p class="ts-info-description">
        Checking this will allow the tenant to use the scheduling of streams
        recording.
      </p>
      <div class="ts-action">
        <div
          class="checkbox-input checkbox-input-burn-subs"
          [class.active]="tenantSettings.AllowRecordingFeature"
        >
          <div (click)="onAllowRecordingFeatureChanged()">
            <svg viewBox="0 0 21.02 14.02">
              <path
                fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
              />
            </svg>
          </div>
        </div>
        <span class="label">Allow recording feature</span>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-scheduler">
    <legend>Scheduler</legend>
    <div class="ts-form-group">
      <div class="ts-action">
        <div
          class="checkbox-input checkbox-input-burn-subs"
          [class.active]="tenantSettings.UseMediaStartTimestampInScheduler"
        >
          <div (click)="onUseMediaStartTimestampInSchedulerChanged()">
            <svg viewBox="0 0 21.02 14.02">
              <path
                fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
              />
            </svg>
          </div>
        </div>
        <span class="label">Use Media StartTimestamp In Scheduler</span>
      </div>
      <div class="ts-action">
        <span class="label">Long Show Seconds</span>
        <icn-number-input
          [min]="0"
          [max]="100000000"
          [step]="1"
          [useDefaultHtmlInput]="true"
          [(value)]="tenantSettings.LongShowSeconds"
          (valueChange)="onLongShowSecondsChanged()"
        ></icn-number-input>
      </div>
      <div class="ts-action">
        <span class="label">Long Show Color</span>
        <icn-color-picker
          [(value)]="tenantSettings.LongShowColorHex"
          (valueChange)="onLongShowColorChanged($event)"
        ></icn-color-picker>
      </div>
      <div class="ts-action">
        <!--<span class="next-show-skip-tags label">Next Show Skip Tags:</span>-->
        <div class="next-show-skip-tags">
          <autocomplete
            [inputLabel]="'Next Show Skip Tags'"
            [inputPlaceholder]="'Add Tags'"
            [feedWithEnter]="false"
            [values]="availableTags"
            [excludes]="tags"
            [key]="'name'"
            [visible]="false"
            (output)="addNewTag($event)"
            (outputNewValue)="createNewTag($event)"
          ></autocomplete>

          <tags-wrapper
            [tags]="tags"
            (onDeleteTag)="deleteExistTag($event)"
          ></tags-wrapper>
        </div>
      </div>
      <div class="ts-action">
        <span class="label">First Day of Work Week</span>

        <icn-dropdown
          [allowMultiple]="false"
          [(selectedValue)]="tenantSettings.FirstDayOfWorkWeek"
          (selectedValueChange)="onFirstDayOfWorkWeekChanged($event)"
        >
          <icn-dropdown-item
            *ngFor="let day of daysOfWeek"
            [value]="day.id"
            [title]="day.name"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-channel-future-preview">
    <legend>Channel Future Preview</legend>
    <div class="ts-form-group">
      <p class="ts-info-description">
        Checking this will allow the tenant to use the scheduling of streams
        recording.
      </p>
      <div class="ts-action">
        <span class="label">Channels Limit</span>
        <icn-number-input
          [min]="0"
          [max]="10"
          [step]="1"
          [useDefaultHtmlInput]="true"
          [(value)]="tenantSettings.PreviewChannelsLimit"
          (valueChange)="onFuturePreviewLimitChanged()"
        ></icn-number-input>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-operations">
    <legend>Operations</legend>
    <div class="ts-form-group availability-zone-dropdown">
      <div class="ts-action">
        <span class="label">Transcoding Availability Zone</span>

        <icn-dropdown
          [large]="true"
          [allowMultiple]="false"
          [(selectedValue)]="tenantSettings.TranscodingAvailabilityZoneId"
          (selectedValueChange)="onTranscodingAvailabilityZoneChanged()"
        >
          <icn-dropdown-item
            *ngFor="let availabilityZone of availabilityZones"
            [value]="availabilityZone.id"
            [title]="availabilityZone.displayName"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>

      <div class="ts-action">
        <span class="label">Live Feed Preview Availability Zone</span>

        <icn-dropdown
          [large]="true"
          [allowMultiple]="false"
          [(selectedValue)]="tenantSettings.LivePreviewAvailabilityZoneId"
          (selectedValueChange)="onLiveFeedPreviewAvailabilityZoneChanged()"
        >
          <icn-dropdown-item
            *ngFor="let availabilityZone of availabilityZones"
            [value]="availabilityZone.id"
            [title]="availabilityZone.displayName"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-metadata">
    <legend>Metadata</legend>
    <div class="ts-form-group">
      <div class="ts-info">
        <p class="ts-info-description">List of the current metadata</p>
      </div>
      <div class="metadata-list-container">
        <div class="metadata-list">
          <div
            class="metadata-item"
            *ngFor="let metadataItem of tenantMetadata"
          >
            <div
              class="metadata-item-name"
              [ngClass]="{
                deleted: isMarkedToAction(metaDataMarkedToDelete, metadataItem),
              }"
              contenteditable="true"
              (blur)="onMetaDataNameBlur(metadataItem, $event)"
            >
              {{ metadataItem.name }}
            </div>
            <div
              class="metadata-item-delete-toggle"
              inlineSVG="/assets/icons/thum-trash.svg"
              (click)="toggleDeleteMetadata(metadataItem)"
            ></div>
          </div>
        </div>
        <div class="metadata-new-item">
          <ichannel-input
            class="metadata-name-input"
            [label]="'Metadata Name'"
            [value]="newMetadataName"
            (output)="newMetadataName = $event"
          >
          </ichannel-input>
          <div class="button apply" (click)="onAddNewMetadataName()">Add</div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-tags">
    <legend>Tags</legend>
    <div class="ts-form-group">
      <div class="ts-info">
        <p class="ts-info-description">List of tenant's tags</p>
      </div>
      <div class="metadata-list-container">
        <div class="metadata-list">
          <div class="metadata-item" *ngFor="let tag of editableTags">
            <div
              class="metadata-item-name"
              [ngClass]="{
                deleted: isMarkedToAction(tagsMarkedToDelete, tag),
                updated: isMarkedToAction(tagsMarkedToUpdate, tag),
                inserted: isMarkedToAction(tagsMarkedToInsert, tag),
              }"
              contenteditable="true"
              (blur)="onTagNameBlur(tag, $event)"
            >
              {{ tag.name }}
            </div>
            <div
              class="metadata-item-delete-toggle"
              inlineSVG="/assets/icons/thum-trash.svg"
              (click)="deleteTagClicked(tag)"
            ></div>
          </div>
        </div>
        <div class="metadata-new-item">
          <ichannel-input
            class="metadata-name-input"
            [label]="'Tag Name'"
            [maxLength]="50"
            [value]="newTagName"
            (output)="newTagName = $event"
          >
          </ichannel-input>
          <div class="button apply" (click)="onAddNewTag()">Add</div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-qc-workflow">
    <legend>QC Workflow</legend>
    <div class="ts-form-group">
      <div class="ts-info">
        <p class="ts-info-description">
          List of tenant's qc workflow objectives
        </p>
      </div>
      <div class="qc-workflow-list-container metadata-list-container">
        <div class="metadata-list qc-workflow-list">
          <div
            class="metadata-item"
            *ngFor="let objective of editableQCWorkflowObjectives"
          >
            <div
              class="metadata-item-name"
              [ngClass]="{
                deleted:
                  isMarkedToAction(
                    qcWorkflowObjectivesMarkedToDelete,
                    objective
                  ) || objective.isDeleted,
                updated: isMarkedToAction(
                  qcWorkflowObjectivesMarkedToUpdate,
                  objective
                ),
                inserted: isMarkedToAction(
                  qcWorkflowObjectivesMarkedToInsert,
                  objective
                ),
              }"
              [attr.contenteditable]="!objective.isDeleted"
              (blur)="
                !objective.isDeleted &&
                  onQCWorkflowObjectiveDescriptionBlur(objective, $event)
              "
            >
              {{ objective.task }}
            </div>
            <div
              *ngIf="!objective.isDeleted"
              class="qc-workflow-delete-toggle metadata-item-delete-toggle"
              inlineSVG="/assets/icons/thum-trash.svg"
              (click)="deleteQCWorkflowObjectiveClicked(objective)"
            ></div>
          </div>
        </div>
        <div class="qc-workflow-new-item metadata-new-item">
          <ichannel-input
            class="metadata-name-input"
            [label]="'New Objective:'"
            [value]="newQCWorkflowObjectiveTask"
            (output)="newQCWorkflowObjectiveTask = $event"
          >
          </ichannel-input>
          <div class="button apply" (click)="onAddNewQCWorkflowObjective()">
            Add
          </div>
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset id="general-settings-broadcasts">
    <legend>Broadcasts</legend>
    <div class="ts-form-group">
      <div class="ts-info">
        <p class="ts-info-description">
          Edit settings related to the broadcasts feature
        </p>
      </div>
      <div class="ts-action">
        <span class="label uppercase"
          >Set broadcast preview static renderer suffix</span
        >
        <ichannel-input
          class="metadata-name-input"
          [label]=""
          [maxLength]="50"
          [value]="tenantSettings.BroadcastsPreviewChannelStaticRendererSuffix"
          (output)="
            onBroadcastsPreviewChannelStaticRendererSuffixChanged($event)
          "
        >
        </ichannel-input>
      </div>
      <div class="ts-action">
        <span class="label uppercase"
          >Set broadcast program static renderer suffix</span
        >
        <ichannel-input
          class="metadata-name-input"
          [label]=""
          [maxLength]="50"
          [value]="tenantSettings.BroadcastsProgramChannelStaticRendererSuffix"
          (output)="
            onBroadcastsProgramChannelStaticRendererSuffixChanged($event)
          "
        >
        </ichannel-input>
      </div>
    </div>
  </fieldset>
</ng-template>

<ng-template #contentControlSettingsCategoriesTemplate>
  <li (click)="onCategoryClick('content-control-ai-detection', $event)">
    AI Detection
  </li>

  <li (click)="onCategoryClick('content-control-transcoding', $event)">
    Transcoding
  </li>
  <li (click)="onCategoryClick('content-control-studio', $event)">Studio</li>
</ng-template>
<ng-template #contentControlSettingsFormTemplate>
  <fieldset id="content-control-ai-detection">
    <legend>AI Detection</legend>
    <div class="ts-form-group">
      <div class="cc-ai-detection-container">
        <div class="cc-ai-detection-table">
          <div class="cc-ai-detection-header">
            <div class="col-arrow"></div>
            <div class="col-module">Module</div>
            <div class="col-type">Type</div>
            <div class="col-enabled">Enabled</div>
            <div class="col-automatic">Automatic</div>
            <div class="col-action">Action</div>
            <div class="col-delete"></div>
          </div>
          <div class="cc-ai-detection-body">
            <ng-container
              *ngFor="
                let detection of tenantSettings.ContentControlAIdetectionsSettings
              "
            >
              <div class="cc-ai-detection-row">
                <div class="col-arrow" [class.expanded]="detection.expanded">
                  <svg
                    class="arrow"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    (click)="toggleExpandRow(detection)"
                  >
                    <path
                      d="M6.60147 15.1954C6.26925 15.5276 6.26925 16.0663 6.60147 16.3985C6.93368 16.7307 7.47231 16.7307 7.80453 16.3985L13.6763 10.5267C13.855 10.348 13.855 10.0581 13.6763 9.8794L7.80453 4.00765C7.47231 3.67543 6.93368 3.67543 6.60147 4.00765C6.26925 4.33986 6.26925 4.87849 6.60147 5.21071L11.5938 10.2031L6.60147 15.1954Z"
                      fill="black"
                      fill-opacity="0.6"
                    />
                  </svg>
                </div>
                <div class="col-module">
                  <mat-form-field appearance="fill">
                    <input
                      matInput
                      type="text"
                      placeholder="Enter module name"
                      [value]="detection.requiredClass.class_name"
                      (change)="
                        detection.requiredClass.class_name =
                          $any($event.target).value;
                        this.pushTenantSettingsChangeToApproveWithoutMessage(
                          TenantSettingsEnum.ContentControlAIdetectionsSettings
                        )
                      "
                    />
                  </mat-form-field>
                </div>
                <div class="col-type">
                  {{ EAiModelType[detection.requiredClass.config.modelType] }}
                  {{ detection.type }}
                </div>
                <div class="col-enabled">
                  <mat-checkbox
                    [checked]="detection.isEnabled"
                    (change)="
                      toggleContentControlAIDetectionIsEnable(detection, $event)
                    "
                  ></mat-checkbox>
                </div>
                <div class="col-automatic">
                  <mat-checkbox
                    [checked]="detection.isAutomaticMitigation"
                    (change)="
                      toggleContentControlAIDetectionIsAutomatic(
                        detection,
                        $event
                      )
                    "
                  ></mat-checkbox>
                </div>
                <div class="col-action">
                  <icn-dropdown
                    [large]="true"
                    [position]="'bottom'"
                    [disabled]="!detection.isAutomaticMitigation"
                    [allowMultiple]="false"
                    [selectedValue]="detection.automaticMitigationAction"
                    (selectedValueChange)="
                      onContentControlAutomaticMitigationActionChanged(
                        detection,
                        $event
                      )
                    "
                  >
                    <icn-dropdown-item
                      *ngFor="
                        let action of ContentControlledEventActionEnum
                          | keyvalue
                      "
                      [value]="action.value"
                      [title]="action.key | humanize"
                    ></icn-dropdown-item>
                  </icn-dropdown>
                </div>
                <div class="col-delete">
                  <svg
                    class="delete-24-px"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    (click)="onDeleteAIDetection(detection)"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM16 9V19H8V9H16ZM6 7H18V19C18 20.1 17.1 21 16 21H8C6.9 21 6 20.1 6 19V7Z"
                      fill="black"
                      fill-opacity="0.54"
                    />
                  </svg>
                </div>
              </div>
              <div
                class="cc-ai-detection-expanded-row"
                [class.expanded]="detection.expanded"
              >
                <!-- Add your expanded content here -->
                <div class="expanded-content flex column">
                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>IOU Threshold</label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          min="10"
                          max="100"
                          step="10"
                          type="number"
                          [value]="
                            detection.requiredClass.config.ioUThreshold * 100
                          "
                          (change)="
                            detection.requiredClass.config.ioUThreshold =
                              $any($event.target).valueAsNumber / 100;
                            this.pushTenantSettingsChangeToApproveWithoutMessage(
                              TenantSettingsEnum.ContentControlAIdetectionsSettings
                            )
                          "
                        />
                        <span matTextSuffix>%</span>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Model IOU</label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          min="10"
                          max="100"
                          step="10"
                          type="number"
                          [value]="
                            detection.requiredClass.config.modelIoU * 100
                          "
                          (change)="
                            detection.requiredClass.config.modelIoU =
                              $any($event.target).valueAsNumber / 100;
                            this.pushTenantSettingsChangeToApproveWithoutMessage(
                              TenantSettingsEnum.ContentControlAIdetectionsSettings
                            )
                          "
                        />
                        <span matTextSuffix>%</span>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Keyframes Delta Threshold</label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          min="1"
                          max="100"
                          step="1"
                          type="number"
                          [value]="
                            detection.requiredClass.config
                              .keyframes_delta_thresh * 100
                          "
                          (change)="
                            detection.requiredClass.config.keyframes_delta_thresh =
                              $any($event.target).valueAsNumber / 100;
                            this.pushTenantSettingsChangeToApproveWithoutMessage(
                              TenantSettingsEnum.ContentControlAIdetectionsSettings
                            )
                          "
                        />
                        <span matTextSuffix>%</span>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Certainty Limit</label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          min="1"
                          max="100"
                          step="1"
                          type="number"
                          [value]="
                            detection.requiredClass.config.certainty_limit * 100
                          "
                          (change)="
                            detection.requiredClass.config.certainty_limit =
                              $any($event.target).valueAsNumber / 100;
                            this.pushTenantSettingsChangeToApproveWithoutMessage(
                              TenantSettingsEnum.ContentControlAIdetectionsSettings
                            )
                          "
                        />
                        <span matTextSuffix>%</span>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Model Confidence</label>
                      <mat-form-field appearance="outline">
                        <input
                          matInput
                          min="1"
                          max="100"
                          step="1"
                          type="number"
                          [value]="
                            detection.requiredClass.config.modelConfidence * 100
                          "
                          (change)="
                            detection.requiredClass.config.modelConfidence =
                              $any($event.target).valueAsNumber / 100;
                            this.pushTenantSettingsChangeToApproveWithoutMessage(
                              TenantSettingsEnum.ContentControlAIdetectionsSettings
                            )
                          "
                        />
                        <span matTextSuffix>%</span>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Trajectory</label>
                      <mat-form-field
                        appearance="outline"
                        class="model-trajectory-field"
                      >
                        <input
                          matInput
                          min="1"
                          max="100"
                          step="1"
                          type="number"
                          [value]="detection.requiredClass.config.trajectory"
                          (change)="
                            detection.requiredClass.config.trajectory =
                              $any($event.target).valueAsNumber;
                            this.pushTenantSettingsChangeToApproveWithoutMessage(
                              TenantSettingsEnum.ContentControlAIdetectionsSettings
                            )
                          "
                        />
                        <span matTextSuffix>Frames</span>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Detection Considerable Gap</label>
                      <mat-form-field
                        appearance="outline"
                        class="model-trajectory-field"
                      >
                        <input
                          matInput
                          min="1"
                          max="100"
                          step="1"
                          type="number"
                          [value]="
                            detection.requiredClass.config
                              .mergeDetectionConsiderableGap
                          "
                          (change)="
                            detection.requiredClass.config.mergeDetectionConsiderableGap =
                              $any($event.target).valueAsNumber;
                            this.pushTenantSettingsChangeToApproveWithoutMessage(
                              TenantSettingsEnum.ContentControlAIdetectionsSettings
                            )
                          "
                        />
                        <span matTextSuffix>Frames</span>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Model URL</label>
                      <mat-form-field
                        appearance="outline"
                        class="model-url-field"
                      >
                        <input
                          matInput
                          type="text"
                          placeholder="Enter model url"
                          [value]="detection.requiredClass.config.modelUrl"
                          (change)="
                            detection.requiredClass.config.modelUrl =
                              $any($event.target).value;
                            this.pushTenantSettingsChangeToApproveWithoutMessage(
                              TenantSettingsEnum.ContentControlAIdetectionsSettings
                            )
                          "
                        />
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Use Cuda</label>
                      <mat-checkbox
                        [checked]="detection.requiredClass.config.useCuda"
                        (change)="
                          detection.requiredClass.config.useCuda =
                            $event.checked;
                          this.pushTenantSettingsChangeToApproveWithoutMessage(
                            TenantSettingsEnum.ContentControlAIdetectionsSettings
                          )
                        "
                      ></mat-checkbox>
                    </div>
                  </div>

                  <div class="flex row">
                    <div class="cc-ai-detection-expanded-row-item">
                      <label>Prime Gpu</label>
                      <mat-checkbox
                        [checked]="detection.requiredClass.config.primeGpu"
                        (change)="
                          detection.requiredClass.config.primeGpu =
                            $event.checked;
                          this.pushTenantSettingsChangeToApproveWithoutMessage(
                            TenantSettingsEnum.ContentControlAIdetectionsSettings
                          )
                        "
                      ></mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <div
          class="ts-link"
          [class.disabled]="!canAddMoreJobs()"
          (click)="canAddMoreJobs() && onAddNewAIDetection()"
        >
          Add Detection
        </div>
      </div>
    </div>
  </fieldset>
  <fieldset id="content-control-transcoding">
    <legend>Transcoding</legend>
    <div class="ts-form-group content-control-dropdown">
      <div class="ts-action">
        <span class="label">Transcoding Profile</span>

        <icn-dropdown
          [large]="true"
          [allowMultiple]="false"
          [(selectedValue)]="tenantSettings.ContentControlTranscodingProfileId"
          (selectedValueChange)="onTranscodingProfileChanged()"
        >
          <icn-dropdown-item
            *ngFor="let transcodingProfile of contentControlTranscodingProfiles"
            [value]="transcodingProfile.id"
            [title]="transcodingProfile.name"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>

      <div class="ts-action">
        <span class="label">Transcoding Destination</span>

        <icn-dropdown
          [large]="true"
          [allowMultiple]="false"
          [(selectedValue)]="
            tenantSettings.ContentControlTranscodingDestinationId
          "
          (selectedValueChange)="onTranscodingDestinationChanged()"
        >
          <icn-dropdown-item
            *ngFor="
              let transcodingDestination of contentControlTranscodingDestinations
            "
            [value]="transcodingDestination.id"
            [title]="transcodingDestination.name"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
    </div>
  </fieldset>
  <fieldset id="content-control-studio">
    <legend>Studio</legend>
    <div class="ts-form-group">
      <p class="ts-info-description">
        Checking this will change the default behavior of the studio to show
        timecode in frames. (default is timestamp 00:00:00.000)
      </p>

      <div class="ts-action">
        <div
          class="checkbox-input"
          [class.active]="
            tenantSettings.DisplayContentControlStudioTimeInFrames
          "
        >
          <div
            (click)="onDisplayContentControlStudioTimeInFramesChanged($event)"
          >
            <svg viewBox="0 0 21.02 14.02">
              <path
                fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
              />
            </svg>
          </div>
        </div>
        <span class="label">Display timecode in frames (00:00:00:00)</span>
      </div>
    </div>
  </fieldset>
</ng-template>

<ng-template #clippingStudioSettingsCategoriesTemplate>
  <li (click)="onCategoryClick('clipping-studio-transcoding', $event)">
    Transcoding
  </li>
</ng-template>
<ng-template #clippingStudioSettingsFormTemplate>
  <fieldset id="clipping-studio-transcoding">
    <legend>Transcoding</legend>
    <div class="ts-form-group content-control-dropdown">
      <div class="ts-action">
        <span class="label">Transcoding Destination</span>
        <icn-dropdown
          [large]="true"
          [position]="'bottom'"
          [allowMultiple]="false"
          [(selectedValue)]="tenantSettings.ClippingStudioTranscodingDestinationId"
          (selectedValueChange)="onClippingStudioTranscodingDestinationChanged()"
        >
          <icn-dropdown-item
            *ngFor="let dest of contentControlTranscodingDestinations"
            [value]="dest.id"
            [title]="dest.name"
          ></icn-dropdown-item>
        </icn-dropdown>
      </div>
      <p class="ts-info-description">
        Technical bucket where Clipping Studio render output is stored.
      </p>
    </div>
  </fieldset>
</ng-template>

<ng-template #destinationsSettingsCategoriesTemplate>
  <li (click)="onCategoryClick('destinations-settings-overview', $event)">
    Overview
  </li>
  <li
    *ngFor="let p of destinationPlatforms"
    (click)="onCategoryClick(destinationsPlatformSectionId(p.platform.platformId), $event)"
    class="destinations-settings-nav-platform"
  >
    <img
      *ngIf="p.platform.iconUrl"
      [src]="p.platform.iconUrl"
      alt=""
      class="destinations-settings-nav-platform__icon"
    />
    {{ p.platform.name }}
  </li>
</ng-template>
<ng-template #destinationsSettingsFormTemplate>
  <fieldset id="destinations-settings-overview">
    <legend>Overview</legend>
    <div class="destinations-overview-stats">
      <p>Connected Accounts: <strong>{{ destinationsOverviewConnectedAccounts }}</strong></p>
      <p>Active Endpoints: <strong>{{ destinationsOverviewActiveEndpoints }}</strong></p>
      <p>Needs Attention: <strong>{{ destinationsOverviewNeedsAttention }}</strong></p>
      <p>Supported Platforms: <strong>{{ destinationsOverviewSupportedPlatforms }}</strong></p>
    </div>
  </fieldset>
  <fieldset
    *ngFor="let p of destinationPlatforms"
    [id]="destinationsPlatformSectionId(p.platform.platformId)"
  >
    <legend class="destinations-settings-platform-legend">
      <img
        *ngIf="p.platform.iconUrl"
        [src]="p.platform.iconUrl"
        alt=""
        class="destinations-settings-platform-legend__icon"
      />
      {{ p.platform.name }}
    </legend>
    <div class="ts-form-group destinations-settings-platform-block">
      <p class="ts-info-note" *ngIf="!p.destinations?.length">
        No destinations connected for this platform.
      </p>
      <p class="ts-info-note" *ngIf="p.destinations?.length">
        <strong>{{ p.destinations.length }}</strong> connected destination<span
          *ngIf="p.destinations.length !== 1"
          >s</span
        >.
      </p>
      <p
        class="ts-info-note destinations-settings-tiktok-note"
        *ngIf="isTikTokPlatform(p.platform) && p.destinations?.length"
      >
        <span>
          TikTok settings must be confirmed for each publication. TikTok does not allow these options to be saved as global defaults, because available privacy and interaction settings can vary by account.
        </span>
        <span
          class="destinations-settings-tiktok-note__help"
          tabindex="0"
          aria-label="TikTok publishing settings information"
        >
          ?
          <span class="destinations-settings-tiktok-note__tooltip">
            TikTok publishing settings are configured per post. TikTok requires visibility and interaction options, such as privacy, comments, Duet and Stitch, to be selected each time content is published. These settings cannot be saved as global defaults because the available options depend on the connected TikTok account and its current privacy settings. You&rsquo;ll be asked to review and confirm TikTok settings during each publication.
          </span>
        </span>
      </p>
      <div class="destinations-accounts-table" *ngIf="p.destinations?.length">
        <div class="destinations-accounts-table__header">
          <div class="col-arrow"></div>
          <div class="col-name">Name</div>
          <div class="col-handle">Handle</div>
          <div class="col-status">Status</div>
          <div *ngIf="canDisconnectDestinations" class="col-delete"></div>
        </div>
        <ng-container *ngFor="let destination of p.destinations">
          <ng-container *ngIf="destinationSettingsState(destination.uid) as settingsState">
          <div class="destinations-accounts-table__row">
            <div
              class="col-arrow"
              [class.expanded]="settingsState.expanded"
              [class.col-arrow--static]="!canShowDestinationSettings(p.platform)"
              (click)="canShowDestinationSettings(p.platform) && toggleDestinationSettings(p.platform, destination)"
            >
              <svg
                *ngIf="canShowDestinationSettings(p.platform)"
                class="arrow"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              ><path d="M6.60147 15.1954C6.26925 15.5276 6.26925 16.0663 6.60147 16.3985C6.93368 16.7307 7.47231 16.7307 7.80453 16.3985L13.6763 10.5267C13.855 10.348 13.855 10.0581 13.6763 9.8794L7.80453 4.00765C7.47231 3.67543 6.93368 3.67543 6.60147 4.00765C6.26925 4.33986 6.26925 4.87849 6.60147 5.21071L11.5938 10.2031L6.60147 15.1954Z" fill="black" fill-opacity="0.6"/></svg>
            </div>
            <div
              class="col-name"
              [class.destinations-accounts-table__name-cell]="canShowDestinationSettings(p.platform)"
              (click)="canShowDestinationSettings(p.platform) && toggleDestinationSettings(p.platform, destination)"
            >{{ destination.displayName }}</div>
            <div class="col-handle">{{ destination.handle ? (destination.handle.startsWith('@') ? destination.handle : '@' + destination.handle) : '' }}</div>
            <div class="col-status">
              <ng-container
                *ngIf="destinationAccountStatusMeta(destination) as statusMeta"
              >
                <span
                  class="destinations-accounts-table__status status-cell"
                  [ngClass]="statusMeta.cssClass"
                >
                  <i
                    [inlineSVG]="statusMeta.icon"
                    class="destinations-accounts-table__status-icon"
                  ></i>
                  <span>{{ statusMeta.label }}</span>
                </span>
              </ng-container>
            </div>
            <div *ngIf="canDisconnectDestinations" class="col-delete">
              <svg
                class="delete-24-px"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                (click)="onDisconnectDestination(p.platform, destination); $event.stopPropagation()"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM16 9V19H8V9H16ZM6 7H18V19C18 20.1 17.1 21 16 21H8C6.9 21 6 20.1 6 19V7Z"
                  fill="black"
                  fill-opacity="0.54"
                />
              </svg>
            </div>
          </div>
            <div
              *ngIf="canShowDestinationSettings(p.platform)"
              class="destinations-accounts-table__expanded-row"
              [class.expanded]="settingsState.expanded"
            >
              <evrideo-destination-settings-panel
                *ngIf="settingsState.expanded"
                [platform]="p.platform"
                [state]="settingsState.panelState"
                [details]="settingsState.details"
                [videoCategories]="settingsState.videoCategories"
                [errorMessage]="settingsState.errorMessage"
                [platformData]="settingsState.draftPlatformData"
                [readonly]="!canEditDestinationSettings"
                [canSave]="canEditDestinationSettings"
                [isSaving]="settingsState.isSaving"
                (platformDataChange)="onDestinationSettingsDraftChange(destination.uid, $event)"
                (save)="onSaveDestinationSettings(p.platform, destination)"
              ></evrideo-destination-settings-panel>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div
        *ngIf="canAddDestinations"
        class="ts-link destinations-settings-add-account"
        [class.disabled]="isAddingDestination"
        (click)="!isAddingDestination && onAddDestination(p.platform.platformId)"
      >
        Add Destination
      </div>
    </div>
  </fieldset>
</ng-template>
